import BaseMap from '../../BaseMap.jsx'
import useDesignTarget from '../ProductMap/useDesignTarget.mjs'
import useHotkeys from '../ProductMap/useHotkeys.mjs'
import useMindMapPlugins from '../ProductMap/useMindMapPlugins.mjs'
import usePermission from '../ProductMap/usePermission.mjs'

import {
    usePluginCommands,
    usePluginPublishProduct,
    usePluginPullProduct,
    usePluginPushProduct,
    usePluginRefreshProduct,
    usePluginReviseProduct,
    usePluginSaveMap,
    usePluginUndoReviseProduct,
} from '../ProductMap/plugins'

import ToolBar from './ToolBar.jsx'
import useReadMap from './useReadMap.mjs'

const components = {ToolBar}

export default function ComponentMap({
    componentId,
    componentType,
    id,
    permission,
    type,
    ...props
}) {
    const readMap = useReadMap(type, id, componentType, componentId)
    const hotkeys = useHotkeys()

    const plugins = [
        useMindMapPlugins(),
        usePermission(permission),

        useDesignTarget({
            componentId,
            componentType,
            productId: id,
            productType: type,
        }),

        usePluginCommands(),
        usePluginPublishProduct(),
        usePluginPullProduct(),
        usePluginPushProduct(),
        usePluginRefreshProduct(),
        usePluginReviseProduct(),
        usePluginSaveMap(),
        usePluginUndoReviseProduct(),
    ]

    return (
        <BaseMap
            components={components}
            hotkeys={hotkeys}
            permission={permission}
            plugins={plugins}
            readMap={readMap}
            {...props}
        />
    )
}
